import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AuthGuard} from '@enerbim/commons-lib';
import {CustomPreloadingStrategyService} from 'app/shared/service/custom-preloading-strategy-service.service';

const APP_ROUTES = [
    {
        path: '',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule)
    },
    {
        // Il faut que l'URL "login" redirige vers la home en ouvrant la popup de login (redirection vers /login faite par intercepteur dans lib commune)
        path: 'login',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
        data: {
            openLoginDialog: true
        }
    },
    {
        path: 'error',
        loadChildren: () => import('./features/error/error.module').then(m => m.ErrorModule)
    },
    {
        path: 'access-denied',
        loadChildren: () => import('./features/error/error.module').then(m => m.ErrorModule),
        data: {
            error403: true
        }
    },
    {
        path: 'password-reset',
        loadChildren: () => import('./lib-routing.modules').then(m => m.PasswordResetModule)
    },
    {
        path: 'inscription/finish',
        loadChildren: () => import('./lib-routing.modules').then(m => m.InscriptionFinishModule)
    },
    {
        path: 'profile',
        canActivate: [AuthGuard],
        loadChildren: () => import('./lib-routing.modules').then(m => m.ProfileModule)
    },
    {
        path: 'changelog',
        canActivate: [AuthGuard],
        loadChildren: () => import('./lib-routing.modules').then(m => m.MarkdownModule),
        data: {
            pageTitle: 'Journal des modifications',
            markdownFile: '/assets/changelog/changelog.md'
        }
    },
    {
        path: 'legal',
        canActivate: [AuthGuard],
        loadChildren: () => import('./lib-routing.modules').then(m => m.MarkdownModule),
        data: {
            pageTitle: 'Informations légales',
            markdownFile: '/assets/legal/mentions-legales.md'
        }
    },
    {
        path: 'admin',
        canActivate: [AuthGuard],
        loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule)
    },
    {
        path: 'referentiel',
        canActivate: [AuthGuard],
        loadChildren: () => import('./features/referentiel/referentiel.module').then(m => m.ReferentielModule)
    },
    {
        path: 'bim/:element-type/:id',
        canActivate: [AuthGuard],
        data: {
            modulePreload: true,
            modulePreloadDelaySeconds: 2,
            moduleName: 'bim',
        },
        loadChildren: () => import('./features/bim/bim.module').then(m => m.BimModule)
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(APP_ROUTES, {
            preloadingStrategy: CustomPreloadingStrategyService
        })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {
}
